<template>
	<div id="logList" class="wp100">
		<el-table :data="tableData" stripe style="width: 100%"
			:header-cell-style="{background:'#ECECEF',color:'#909399'}">
			<!-- <el-table-column prop="cb_status.name" width="80px" label="状态">
			</el-table-column> -->
			<el-table-column prop="log_title" width="80px" label="类型">
			</el-table-column>
			<el-table-column prop="content" label="修改建议">
			</el-table-column>
			<el-table-column prop="add_time" width="160px" label="添加时间">
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				cbId: 0,
				tableData: []
			};
		},
		methods: {
			init(cbId) {
				this.cbId = cbId || 0;
				this.$api.contribute
					.contributionDetail(cbId)
					.then((res) => {
						this.tableData = res.Data.LogList
						// if (res.Data.LogList.length > 0) {
						// 	this.tableData = res.Data.LogList.filter(item => item.log_type.logType == 0 && item
						// 		.log_title == "意见反馈");
						// }
					})
					.catch((res) => {});
			},
		},
	};
</script>

<style>
</style>
